export default __webpack_public_path__ + "static/media/folderbigicon.de503000.svg";